import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Forgot your password", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "info mb-4" }, " Enter your email address to reset your password. You may need to check your spam folder or unblock info@reply200.com. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "info size-big mb-6" }, " Nice! We have sent you an email with the confirmation link. ", -1)

import { reactive, ref } from 'vue';
import { useAccountStore } from '@/stores/account';
import { useRouter } from 'vue-router';
import { useErrors } from '@/utils/use-errors';
import VAuthInput from '@/components/VAuthInput.vue';
import VButton from '@/components/VButton.vue'
import MailIcon from '@/components/icons/other/MailIcon.vue'
import { useTitle } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthForgotForm',
  setup(__props) {

const values = reactive({ email: "" })
const { errors, checkRequired } = useErrors(values)

const accountStore = useAccountStore()
const router = useRouter()

const mode = ref<"init" | "sended">("init")

const pending = ref(false)
const apply = async (e: Event) => {
  e.preventDefault()
  if (!checkRequired([ 'email' ])) return
  pending.value = true
  try {
    await accountStore.forgotPassword(values)
    mode.value = "sended"
  } catch(e) {
    const body = (e as any).body
    errors.email = body.message || "An error occurred"
    pending.value = false
  }
}

const goBack = () => {
  router.push("/")
}

useTitle("Forgot your password | Reply200")


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "auth__form",
    onSubmit: apply
  }, [
    _hoisted_1,
    (mode.value === 'init')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createVNode(VAuthInput, {
            modelValue: values.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((values.email) = $event)),
            error: _unref(errors).email,
            icon: MailIcon,
            placeholder: "Your Email",
            class: "mb-4"
          }, null, 8, ["modelValue", "error"]),
          _createVNode(VButton, {
            class: "primary mb-4",
            type: "submit",
            disabled: pending.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Confirm ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_3,
          _createVNode(VButton, {
            class: "primary mb-4",
            onClick: goBack
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Back to Log In ")
            ]),
            _: 1
          })
        ], 64))
  ], 32))
}
}

})